import React from "react"
import "./index.css"
import Home from "./pages/home/Homepage"

const App = () => {
    return <Home />
}

export default App
